import { useContext } from "react";
import { AuthContext } from "../Context/Auth/AuthContenxt";
import { AuthContextValue } from "../Context/Auth/AuthInterface";

export const useAuth = (): AuthContextValue => {
  return useContext(AuthContext);
};
